import React, { useEffect } from "react";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import CloseIcon from "static/svg/close.svg";
import { trackEvent } from "/services/bigbrain-service";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import { SM } from "constants/sizes";
import { SIGNUP_POPUP_OPENED } from "constants/bigbrain-event-types.js";

import { componentStyles } from "./signup-popup-screen-component.scss";

const SignupPopupScreenComponent = (props) => {
  const { translate, closePopupAction, beforeSubmitCallback } = props;

  useEffect(() => {
    trackEvent(SIGNUP_POPUP_OPENED);
  }, []);

  const closeModalAction = () => {
    closePopupAction && closePopupAction({ placement: "clicked_on_close_icon" });
  };

  const onKeyDown = generateOnKeyDownHandler(closeModalAction);

  return (
    <div className="signup-popup-screen">
      <div
        className="signup-popup-close"
        onClick={closeModalAction}
        onKeyDown={onKeyDown}
        tabIndex={0}
        role="button"
        aria-label={translate("signupPopup.close")}
      >
        <CloseIcon className="close-icon" />
      </div>

      <div className="signup-popup-content">
        <div className="signup-popup-title">{translate("signup.ctaSignupForFree")}</div>
        <div className="signup-popup-subtitle">{translate("signupPopup.subtitle")}</div>
        <div className="popup-email-signup-wrapper">
          <SignupButton
            forceDefaultForm={true}
            useCtaText={true}
            ctaText={translate("signup.continueCta")}
            withButtonArrow={false}
            forceVerticalGoogleConnect={true}
            buttonSize={SM}
            googleOverrideCtaKey="signup.ctaSignupWith"
            focusOnLoad={true}
            isLocatedInPopup={true}
            beforeSubmitCallback={beforeSubmitCallback}
          />
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default SignupPopupScreenComponent;
